export const Debug = {
  log: (message1: any, message2?: any) => {
    if (process.env.NODE_ENV !== 'production') {
      console.log(message1, message2);
    }
  }
};
